import { render } from "./StudentClassesSelectPopup.vue?vue&type=template&id=623b2de4&scoped=true&ts=true"
import script from "./StudentClassesSelectPopup.vue?vue&type=script&lang=ts"
export * from "./StudentClassesSelectPopup.vue?vue&type=script&lang=ts"

import "./StudentClassesSelectPopup.vue?vue&type=style&index=0&id=623b2de4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623b2de4"]])

export default __exports__